import { render, staticRenderFns } from "./CaricamentoPolizze.vue?vue&type=template&id=7ca5da39&scoped=true"
import script from "./CaricamentoPolizze.vue?vue&type=script&lang=ts"
export * from "./CaricamentoPolizze.vue?vue&type=script&lang=ts"
import style0 from "./CaricamentoPolizze.vue?vue&type=style&index=0&id=7ca5da39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca5da39",
  null
  
)

export default component.exports